import { useAuthValidation } from '../../hooks/useAuthValidation';

import { View } from './view';

export const UserWorkzone = () => {
    useAuthValidation();
    return View();
};
